"use client"

import { FC, ReactNode } from "react"
import { NoResultsIllustration } from "./icons"
import {
  NoResults as NoResultsWrapper,
  NoResultsIcon,
  NoResultsTitle,
  ResetButton,
} from "./styles"

interface NoResultsProps {
  title: ReactNode
  resetLabel: string
  onReset: () => void
}

const NoResults: FC<NoResultsProps> = ({ title, resetLabel, onReset }) => (
  <NoResultsWrapper>
    <NoResultsIcon aria-hidden="true">
      <NoResultsIllustration />
    </NoResultsIcon>
    <NoResultsTitle>{title}</NoResultsTitle>
    <ResetButton type="button" onClick={onReset}>
      {resetLabel}
    </ResetButton>
  </NoResultsWrapper>
)

export default NoResults
